/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Menu on a `dxp-accent` 0.16 opacity background.
 * @export
 */
export const CUSTOM_ICON_MENU = (
  <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#1D9BE2" fillOpacity="0.16" height="32" rx="16" width="32" />
    <path
      clipRule="evenodd"
      d="M9.33333 12.6667C8.875 12.6667 8.5 12.2917 8.5 11.8333C8.5 11.375 8.875 11 9.33333 11H22.6667C23.125 11 23.5 11.375 23.5 11.8333C23.5 12.2917 23.125 12.6667 22.6667 12.6667H9.33333ZM9.33333 16.8333H22.6667C23.125 16.8333 23.5 16.4583 23.5 16C23.5 15.5417 23.125 15.1667 22.6667 15.1667H9.33333C8.875 15.1667 8.5 15.5417 8.5 16C8.5 16.4583 8.875 16.8333 9.33333 16.8333ZM9.33333 21H22.6667C23.125 21 23.5 20.625 23.5 20.1667C23.5 19.7083 23.125 19.3333 22.6667 19.3333H9.33333C8.875 19.3333 8.5 19.7083 8.5 20.1667C8.5 20.625 8.875 21 9.33333 21Z"
      fill="white"
      fillOpacity="0.6"
      fillRule="evenodd"
    />
  </svg>
);
